module.exports = __webpack_public_path__ + "media/images/icons/idea-icon-7d5e398110a3286f1ba0336486182b46.svg";